import { parseTimeDeprecated } from '../../utils/time';

export const validateTime = (value?: string) => {
  if (!value) return false;
  const date = parseTimeDeprecated(value);
  return date?.isValid();
};
